/* Jay - Cookie Banner: Remove "Decline" button */
window.onload = function () {
  try {
    document
      .getElementById("shopify-pc__prefs__header-decline")
      .setAttribute("style", "display: none");
    document
      .getElementById("shopify-pc__banner__btn-decline")
      .setAttribute("style", "display: none");
    document
      .getElementById("shopify-mobile__prefs__header-decline")
      .setAttribute("style", "display: none");
    document
      .getElementById("shopify-mobile__banner__btn-decline")
      .setAttribute("style", "display: none");
  } catch (e) {}
};

/* Cookie Banner missing aria ID */
/* Ignacio - [ADA2_11] Fix aria-labelledby by adding the missing ID to Cookie Banner */
setTimeout(() => {
  try {
    const observer = new MutationObserver(() => {
      const section = document.querySelector("#shopify-pc__banner");
      if (section) {
        const bannerBody = section.querySelector(".shopify-pc__banner__body p");
        if (bannerBody && !bannerBody.id) {
          bannerBody.setAttribute("id", "shopify-pc__banner__body-title");
          observer.disconnect();
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(() => observer.disconnect(), 4000);
  } catch (e) {}
}, 800); // delay starting the observer